/**
 * Checks if a nullable value is null and narrows its type to the non-null
 * type if it is not null.
 * @param value any value
 * @returns whether the value is non-null
 */
export function isNonNull<T>(value: T | null): value is T {
    return !!value;
}
